import { Typography, Box } from "@mui/material";
import IceMillerLogo from "../assets/IceMiller_logo_color.svg";

export function SponsorTile() {
    return (
        <Box
            sx={{
                width: "max(165.29px, 17.5781vw)",
                height: "auto",
                borderRadius: "max(12px,2.315vh) max(12px,2.315vh) 0px 0px",
                background: "#F2F2F2 0% 0% no-repeat padding-box",
                position: "absolute",
                top: "max(100%)", // This is a percentage of the parent
                left: "50%", // This is a percentage of the parent
                transform: "translate(-50%, -100%)", //Translate percentage is based on the element's size, not parent
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                aspectRatio: "675/285"
            }}
        >
            <Typography
                sx={{
                    color: "text.logo",
                    fontSize: "max(11px,1.3889vh)",
                    lineHeight: "max(16px,1.6204vh)",
                    letterSpacing: "0.0287px",
                    textAlign: "center",
                    padding: "0px 15px 0px 15px"
                }}
            > 
                Meet the Artists is Generously Sponsored By
            </Typography>
            <img
                alt="Ice Miller sponsor logo"
                src={IceMillerLogo}
                style={{
                    height: "max(13.226px, 2.5vh)",
                    margin: ".949vh 0 .949vh 0"
                }}
            />
            <Typography
                sx={{
                    color: "text.logo",
                    fontSize: "max(11px,1.3889vh)",
                    lineHeight: "max(16px,1.6204vh)",
                    letterSpacing: "0.0287px",
                    textAlign: "center",
                    padding: "0px 15px 0px 15px"
                }}
            > 
                and its Racial Equity Solutions Team
            </Typography>
        </Box>
    )
}